export default "__VITE_ASSET__BOXB5VSU__"